module.exports = __webpack_public_path__ + "bf9bef82e08807c376d893c5395df113.pdf";